/**
 * Portfolio Redux Slice
 */

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';

const initialState = {
  holdings: [],
  positions: [],
  funds: null,
  loading: false,
  error: null,
};

// Fetch holdings
export const fetchHoldings = createAsyncThunk(
  'portfolio/fetchHoldings',
  async (productType = 'CNC', { getState, rejectWithValue }) => {
    try {
      const { auth } = getState();
      const response = await api.get(`/portfolio/holdings/${productType}`, {
        headers: { Authorization: `Bearer ${auth.userSession}` },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: error.message });
    }
  }
);

// Fetch positions
export const fetchPositions = createAsyncThunk(
  'portfolio/fetchPositions',
  async (_, { getState, rejectWithValue }) => {
    try {
      const { auth } = getState();
      const response = await api.get('/portfolio/positions', {
        headers: { Authorization: `Bearer ${auth.userSession}` },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: error.message });
    }
  }
);

// Fetch funds
export const fetchFunds = createAsyncThunk(
  'portfolio/fetchFunds',
  async (_, { getState, rejectWithValue }) => {
    try {
      const { auth } = getState();
      const response = await api.get('/account/funds', {
        headers: { Authorization: `Bearer ${auth.userSession}` },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: error.message });
    }
  }
);

const portfolioSlice = createSlice({
  name: 'portfolio',
  initialState,
  reducers: {
    clearPortfolio: (state) => {
      state.holdings = [];
      state.positions = [];
      state.funds = null;
    },
  },
  extraReducers: (builder) => {
    // Fetch Holdings
    builder.addCase(fetchHoldings.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchHoldings.fulfilled, (state, action) => {
      state.loading = false;
      state.holdings = action.payload.data || [];
    });
    builder.addCase(fetchHoldings.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload?.error || 'Failed to fetch holdings';
    });

    // Fetch Positions
    builder.addCase(fetchPositions.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchPositions.fulfilled, (state, action) => {
      state.loading = false;
      state.positions = action.payload.data || [];
    });
    builder.addCase(fetchPositions.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload?.error || 'Failed to fetch positions';
    });

    // Fetch Funds
    builder.addCase(fetchFunds.fulfilled, (state, action) => {
      state.funds = action.payload.data || null;
    });
  },
});

export const { clearPortfolio } = portfolioSlice.actions;
export default portfolioSlice.reducer;
